import { Fragment, useCallback } from 'react'
import { ButtonSecondary } from '../../../../../baseComponents/Button'
import { ModalOpenedSetTy } from '../../../../../baseComponents/Modal/types'
import ModalSmallFilled from '../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { twinFetchPostText } from '../../../../../utils/globals/data'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'

interface ConfigProductCodebarsProps {
    getData: () => Promise<void>
    className: string
}

export const ConfigProductCodebars: React.FC<ConfigProductCodebarsProps> = ({ getData, className }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <div className={'gap-10 flex flex-row items-center ' + (className || '')}>
                <span><TwinTrans transKey={'autogenerateBarcodesForExistingProducts'}>Autogenerar códigos de barra para los productos existentes</TwinTrans>:</span>
                <ButtonSecondary className='w-fit' type='button' onClick={() => setOpenModal({ type: 'edit', allRowData: {} })} key={'autogenerateCodebar'}><TwinTrans transKey={'autogenerate'}>Autogenerar</TwinTrans></ButtonSecondary>
            </div>
            {openModal?.type === 'edit' ? <ModalGenerateProductCodebars onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
        </Fragment>
    )
}

interface ModalGenerateProductCodebarsProps extends ModalEditComponentProps { }

const ModalGenerateProductCodebars: React.FC<ModalGenerateProductCodebarsProps> = ({ setOpened }) => {
    const { t } = useTwinTranslation()
    const { updateAllProductCodebars } = useModalGenerateProductCodebarsLogic({setOpened})
    return (<ModalSmallFilled translations={{
        title: t('autogenerateCodebars', 'Autogenerar códigos de barras'),
        subtitle: t('sureAcceptAutogenerateExistingProductCodebars', '¿Estás seguro de querer autogenerar los códigos de barras de todos los productos?'),
        buttonAccept: t('accept', 'Aceptar'),
    }} onAccept={updateAllProductCodebars} opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} />)
}

interface ModalGenerateProductCodebarsLogicProps {
    setOpened: ModalOpenedSetTy
}

const useModalGenerateProductCodebarsLogic = ({ setOpened }: ModalGenerateProductCodebarsLogicProps) => {
    const updateAllProductCodebars = useCallback(async () => {
        const result = await twinFetchPostText('/api/app/product/updateAllProductCodebars', { })
        if (result) {
            setOpened(null)
        }
    }, [setOpened])
    return { updateAllProductCodebars }
}

export default ConfigProductCodebars